import { ChangeDetectorRef, Directive, Injector, OnChanges, OnDestroy, OnInit, ViewRef, inject } from '@angular/core';
import { Client } from '@df/core/service/client';
import { TimeoutService } from '@df/ng/timeout.service';
import { Subscription } from 'rxjs';

@Directive()
export abstract class UiComponent implements OnInit, OnChanges, OnDestroy {
    /**
     * If componet is past init
     */
    initiated = false;

    /**
     * If asynchronous change detection is allowed
     */
    protected asyncCd = false;

    /**
     * If can detach
     */
    protected canDetach = false;

    /**
     * Subscriptions
     */
    protected readonly subscriptions = new Subscription();

    readonly injector = inject(Injector);
    readonly changeDetectorRef = inject(ChangeDetectorRef);
    protected timeoutService = inject(TimeoutService);
    readonly client = inject(Client);

    /**
     * Initialisation hook
     */
    ngOnInit(): void {
        if (this.canDetach) {
            this.changeDetectorRef.detach();
        }
        this.subscriptions.add(this.client.obs.breakpoint.subscribe(() => this.onBreakpoint()));
        this.initiated = true;
        if (this.canDetach) {
            this.detectChanges();
        }
    }

    /**
     * Changes hook
     */
    ngOnChanges(changes): void {
        this.detectChanges();
    }

    /**
     * Destroy hook
     */
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    protected onBreakpoint() {
        this.detectChanges();
    }

    /**
     * Change detection
     */
    detectChanges(): void {
        if (this.initiated) {
            const cd = () => {
                if (!(<ViewRef>this.changeDetectorRef).destroyed) {
                    this.changeDetectorRef.detectChanges();
                }
            };
            if (this.asyncCd) {
                this.timeoutService.async(cd);
            } else {
                cd();
            }
        }
    }
}
